'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Lama$1(name, age, splitDistance, color) {
  this.t2 = null;
  this.t0 = 0;
  this.t3 = 0;
  this.t1 = null;
  this.t2 = name;
  this.t0 = age;
  this.t3 = splitDistance;
  this.t1 = color;
}
export { $c_Lsamples_Sealed$package$Lama$1 as $c_Lsamples_Sealed$package$Lama$1 };
$p = $c_Lsamples_Sealed$package$Lama$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Lama$1;
/** @constructor */
function $h_Lsamples_Sealed$package$Lama$1() {
}
export { $h_Lsamples_Sealed$package$Lama$1 as $h_Lsamples_Sealed$package$Lama$1 };
$h_Lsamples_Sealed$package$Lama$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 2360809);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.t2));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.t0);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.t3);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.t1));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Sealed$package$Lama$1)) {
    if ((((this.t0 === x$0.t0) && (this.t3 === x$0.t3)) && (this.t2 === x$0.t2))) {
      var x = this.t1;
      var x$2 = x$0.t1;
      return ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "Lama";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.t2;
      break;
    }
    case 1: {
      return this.t0;
      break;
    }
    case 2: {
      return this.t3;
      break;
    }
    case 3: {
      return this.t1;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Sealed$package$Lama$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ep)));
}
export { $isArrayOf_Lsamples_Sealed$package$Lama$1 as $isArrayOf_Lsamples_Sealed$package$Lama$1 };
var $d_Lsamples_Sealed$package$Lama$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Lama$1, "samples.Sealed$package$Lama$1", ({
  ep: 1,
  by: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sealed$package$Lama$1 as $d_Lsamples_Sealed$package$Lama$1 };
